const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua And Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia And Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic Of The',
  'Cook Islands',
  'Costa Rica',
  'Cote D\'ivoire',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea-bissau',
  'Guyana',
  'Haiti',
  'Heard Island And Mcdonald Islands',
  'Holy See (vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic Of',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic Of',
  'Korea, Republic Of',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia, The Former Yugoslav Republic Of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States Of',
  'Moldova, Republic Of',
  'Monaco',
  'Mongolia',
  'Montserrat',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Helena',
  'Saint Kitts And Nevis',
  'Saint Lucia',
  'Saint Pierre And Miquelon',
  'Saint Vincent And The Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome And Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia And The South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard And Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province Of China',
  'Tajikistan',
  'Tanzania, United Republic Of',
  'Thailand',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad And Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks And Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.s.',
  'Wallis And Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];
const canadianProvinces = [
  {code: 'AB', name: 'Alberta'},
  {code: 'BC', name: 'British Columbia'},
  {code: 'MB', name: 'Manitoba'},
  {code: 'NB', name: 'New Brunswick'},
  {code: 'NL', name: 'Newfoundland and Labrador'},
  {code: 'NS', name: 'Nova Scotia'},
  {code: 'NT', name: 'Northwest Territories'},
  {code: 'NU', name: 'Nunavut'},
  {code: 'ON', name: 'Ontario'},
  {code: 'PE', name: 'Prince Edward Island'},
  {code: 'QC', name: 'Quebec'},
  {code: 'SK', name: 'Saskatchewan'},
  {code: 'YT', name: 'Yukon'}
];
const americanStates = [
  {code: 'AL', name: 'Alabama'},
  {code: 'AK', name: 'Alaska'},
  {code: 'AZ', name: 'Arizona'},
  {code: 'AR', name: 'Arkansas'},
  {code: 'CA', name: 'California'},
  {code: 'CO', name: 'Colorado'},
  {code: 'CT', name: 'Connecticut'},
  {code: 'DE', name: 'Delaware'},
  {code: 'DC', name: 'District Of Columbia'},
  {code: 'FL', name: 'Florida'},
  {code: 'GA', name: 'Georgia'},
  {code: 'HI', name: 'Hawaii'},
  {code: 'ID', name: 'Idaho'},
  {code: 'IL', name: 'Illinois'},
  {code: 'IN', name: 'Indiana'},
  {code: 'IA', name: 'Iowa'},
  {code: 'KS', name: 'Kansas'},
  {code: 'KY', name: 'Kentucky'},
  {code: 'LA', name: 'Louisiana'},
  {code: 'ME', name: 'Maine'},
  {code: 'MD', name: 'Maryland'},
  {code: 'MA', name: 'Massachusetts'},
  {code: 'MI', name: 'Michigan'},
  {code: 'MN', name: 'Minnesota'},
  {code: 'MS', name: 'Mississippi'},
  {code: 'MO', name: 'Missouri'},
  {code: 'MT', name: 'Montana'},
  {code: 'NE', name: 'Nebraska'},
  {code: 'NV', name: 'Nevada'},
  {code: 'NH', name: 'New Hampshire'},
  {code: 'NJ', name: 'New Jersey'},
  {code: 'NM', name: 'New Mexico'},
  {code: 'NY', name: 'New York'},
  {code: 'NC', name: 'North Carolina'},
  {code: 'ND', name: 'North Dakota'},
  {code: 'OH', name: 'Ohio'},
  {code: 'OK', name: 'Oklahoma'},
  {code: 'OR', name: 'Oregon'},
  {code: 'PA', name: 'Pennsylvania'},
  {code: 'RI', name: 'Rhode Island'},
  {code: 'SC', name: 'South Carolina'},
  {code: 'SD', name: 'South Dakota'},
  {code: 'TN', name: 'Tennessee'},
  {code: 'TX', name: 'Texas'},
  {code: 'UT', name: 'Utah'},
  {code: 'VT', name: 'Vermont'},
  {code: 'VA', name: 'Virginia'},
  {code: 'WA', name: 'Washington'},
  {code: 'WV', name: 'West Virginia'},
  {code: 'WI', name: 'Wisconsin'},
  {code: 'WY', name: 'Wyoming'}
];
const indianStates = [
  {code: 'AN', name: 'Andaman and Nicobar Islands'},
  {code: 'AP', name: 'Andhra Pradesh'},
  {code: 'AR', name: 'Arunachal Pradesh'},
  {code: 'AS', name: 'Assam'},
  {code: 'BR', name: 'Bihar'},
  {code: 'CH', name: 'Chandigarh'},
  {code: 'CT', name: 'Chhattisgarhr'},
  {code: 'DN', name: 'Dadra and Nagar Haveli'},
  {code: 'DD', name: 'Daman and Diu'},
  {code: 'DL', name: 'Dehli'},
  {code: 'GA', name: 'Goa'},
  {code: 'GJ', name: 'Gujarat'},
  {code: 'HR', name: 'Haryana'},
  {code: 'HP', name: 'Himachal Pradesh'},
  {code: 'JK', name: 'Jammu and Kashmir'},
  {code: 'JH', name: 'Jharkhand'},
  {code: 'KA', name: 'Karnataka'},
  {code: 'KL', name: 'Kerala'},
  {code: 'LD', name: 'Lakshadweep'},
  {code: 'MP', name: 'Madhya Pradesh'},
  {code: 'MH', name: 'Maharashtra'},
  {code: 'MN', name: 'Manipur'},
  {code: 'ML', name: 'Meghalaya'},
  {code: 'MZ', name: 'Mizoram'},
  {code: 'NL', name: 'Nagaland'},
  {code: 'OD', name: 'Odisha'},
  {code: 'PY', name: 'Puducherry'},
  {code: 'PB', name: 'Punjab'},
  {code: 'RJ', name: 'Rajasthan'},
  {code: 'SK', name: 'Sikkim'},
  {code: 'TN', name: 'Tamil Nadu'},
  {code: 'TS', name: 'Telangana'},
  {code: 'TR', name: 'Tripura'},
  {code: 'UP', name: 'Uttar Pradesh'},
  {code: 'UK', name: 'Uttarakhand'},
  {code: 'WB', name: 'West Bengal'}
];
const mexicanStates = [
  {code: 'AGU', name: 'Aguascalientes'},
  {code: 'BCN', name: 'Baja California'},
  {code: 'BCS', name: 'Baja California Sur'},
  {code: 'CAM', name: 'Campeche'},
  {code: 'CHP', name: 'Chiapas'},
  {code: 'CHH', name: 'Chihuahua'},
  {code: 'COA', name: 'Coahuila'},
  {code: 'COL', name: 'Colima'},
  {code: 'CMX', name: 'Ciudad de Mexico'},
  {code: 'DUR', name: 'Durango'},
  {code: 'GUA', name: 'Guanajuato'},
  {code: 'GRO', name: 'Guerrero'},
  {code: 'HID', name: 'Hidalgo'},
  {code: 'JAL', name: 'Jalisco'},
  {code: 'MEX', name: 'Mexico'},
  {code: 'MIC', name: 'Michoacan'},
  {code: 'MOR', name: 'Morelos'},
  {code: 'NAY', name: 'Nayarit'},
  {code: 'NLE', name: 'Nuevo Leon'},
  {code: 'OAX', name: 'Oaxaca'},
  {code: 'PUE', name: 'Puebla'},
  {code: 'QUE', name: 'Queretaro'},
  {code: 'ROO', name: 'Quintana Roo'},
  {code: 'SLP', name: 'San Luis Potosi'},
  {code: 'SIN', name: 'Sinaloa'},
  {code: 'SON', name: 'Sonora'},
  {code: 'TAB', name: 'Tabasco'},
  {code: 'TAM', name: 'Tamaulipas'},
  {code: 'TLA', name: 'Tlaxcala'},
  {code: 'VER', name: 'Veracruz'},
  {code: 'YUC', name: 'Yucatan'},
  {code: 'ZAC', name: 'Zacatecas'}
];
export default class Regionalization {

  static getCountries() {
    return countries;
  }

  static getStatesOrProvinces(country) {
    if (country === 'Canada') {
      return canadianProvinces;
    }
    if (country === 'India') {
      return indianStates;
    }
    if (country === 'Mexico') {
      return mexicanStates;
    }
    if (country === 'United States') {
      return americanStates;
    }
    return [{
      code: 'Other',
      name: 'Other'
    }];
  }

  static isValidStateOrProvinces(country, stateOrProvince) {
    if (country === 'Canada') {
      return canadianProvinces.find(x => x.code === stateOrProvince) !== null;
    }
    if (country === 'India') {
      return indianStates.find(x => x.code === stateOrProvince) !== null;
    }
    if (country === 'Mexico') {
      return mexicanStates.find(x => x.code === stateOrProvince) !== null;
    }
    if (country === 'United States') {
      return americanStates.find(x => x.code === stateOrProvince) !== null;
    }
    return (stateOrProvince === 'Other');
  }

  static hasStatesOrProvinces(country) {
    return (country === 'Canada' || country === 'India' || country === 'Mexico' || country === 'United States');
  }

  static getRegionDataFromProfile(profile) {
    const { contractId, country, stateOrProvince, cityOrMunicipality } = profile;
    return { contractId, country, stateOrProvince, cityOrMunicipality };
  }

  static match(regionData, filter) {
    if (regionData.contractId && regionData.contractId === filter) return true;
    return (`${regionData.country}/${regionData.stateOrProvince}/${regionData.cityOrMunicipality}`).indexOf(filter) === 0;
  }
}



// WEBPACK FOOTER //
// ./src/services/regionalization.js